/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { PraticaDtoFromJSON, } from '../models';
/**
 *
 */
export class PraticaApi extends runtime.BaseAPI {
    /**
     */
    avviaPraticaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.codiceAttivazione === null || requestParameters.codiceAttivazione === undefined) {
                throw new runtime.RequiredError('codiceAttivazione', 'Required parameter requestParameters.codiceAttivazione was null or undefined when calling avviaPratica.');
            }
            const queryParameters = {};
            if (requestParameters.codiceAttivazione !== undefined) {
                queryParameters['codiceAttivazione'] = requestParameters.codiceAttivazione;
            }
            if (requestParameters.dealer !== undefined) {
                queryParameters['dealer'] = requestParameters.dealer;
            }
            if (requestParameters.isFidoTest !== undefined) {
                queryParameters['isFidoTest'] = requestParameters.isFidoTest;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/pratica/avviaPratica`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PraticaDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    avviaPratica(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.avviaPraticaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    suspendPraticaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling suspendPratica.');
            }
            if (requestParameters.stepStatus === null || requestParameters.stepStatus === undefined) {
                throw new runtime.RequiredError('stepStatus', 'Required parameter requestParameters.stepStatus was null or undefined when calling suspendPratica.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.stepStatus !== undefined) {
                queryParameters['stepStatus'] = requestParameters.stepStatus;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/pratica/suspendPratica`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PraticaDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    suspendPratica(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.suspendPraticaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const SuspendPraticaStepStatusEnum = {
    AvviaPratica: 'AVVIA_PRATICA',
    RicercaAzienda: 'RICERCA_AZIENDA',
    RegistraAzienda: 'REGISTRA_AZIENDA',
    RicercaRappLegale: 'RICERCA_RAPP_LEGALE',
    RegistraRappLegale: 'REGISTRA_RAPP_LEGALE',
    RicercaTitolari: 'RICERCA_TITOLARI',
    RegistraTitolare: 'REGISTRA_TITOLARE',
    ConfiguraServizio: 'CONFIGURA_SERVIZIO',
    DatiPagamento: 'DATI_PAGAMENTO',
    VerificaIdentita: 'VERIFICA_IDENTITA',
    FirmaContratto: 'FIRMA_CONTRATTO',
    FinePratica: 'FINE_PRATICA'
};
